import { createUseStyles } from 'react-jss';

export default createUseStyles({
  root: {
    '& > div:not(:last-child)': {
      marginBottom: 10
    }
  }
});
